import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { useABTestWizardStore } from '@/store/ab-test/wizardStore';
import { ABTestVideoCard } from './ABTestVideoCard';

export function ABTestTrafficDistributionStep() {
  useLanguage();
  const { data, updatePercentage } = useABTestWizardStore();
  const { selectedVideos, trafficDistribution } = data;

  const handlePercentageChange = (videoId: string, newPercentage: number) => {
    updatePercentage(videoId, newPercentage);
  };

  return (
    <div className="flex flex-col animate-fade-in w-full max-w-6xl mx-auto min-h-0">
      {/* Header */}
      <div className="flex-shrink-0 px-4 sm:px-6 lg:px-8 pt-4 lg:pt-6">
        <h2 className="text-[20px] lg:text-[22px] font-semibold text-foreground">
          {translateInterfaceText("Distribuição de Tráfego")}</h2>
        <p className="text-[15px] text-muted-foreground mt-1.5 leading-relaxed">
          {translateInterfaceText("Defina a porcentagem de tráfego que cada vídeo receberá no teste.")}</p>
      </div>

      {/* Videos Grid */}
      <div className="flex-1 overflow-y-auto overflow-x-hidden px-4 sm:px-6 lg:px-8 mt-6 pb-24 lg:pb-6 min-h-0">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 lg:gap-5">
          {selectedVideos.map((video, index) => (
            <ABTestVideoCard
              key={video.id}
              video={video}
              index={index}
              percentage={trafficDistribution.percentages[video.id] || 0}
              onPercentageChange={handlePercentageChange}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
